function isClubGG(app: string | null): boolean {
  return normalizeApp(app).includes('CLUBGG');
}

function normalizeApp(app: string | null): string {
  return (app ?? '').toUpperCase().replace(/\s+/g, '');
}

/**
 * ClubGG referral codes are displayed as XXXX-XXXX.
 * Accepts 8 consecutive digits, XXXX-XXXX, or XXXX XXXX from the API.
 */
export function normalizeClubGGReferralCode(refNumber: string): string {
  const digits = refNumber.replace(/\D/g, '');

  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  }

  const spacedOrDashed = refNumber.trim().match(/^(\d{4})\s*[-–]?\s*(\d{4})$/);
  if (spacedOrDashed) {
    return `${spacedOrDashed[1]}-${spacedOrDashed[2]}`;
  }

  return refNumber.trim().toUpperCase();
}

export function normalizeReferralCode(app: string | null, refNumber: string | null): string {
  if (!refNumber || refNumber.trim().length === 0) {
    return '—';
  }

  if (isClubGG(app)) {
    return normalizeClubGGReferralCode(refNumber);
  }

  return refNumber.trim().toUpperCase();
}
